import { create } from 'zustand';
import { inboxApi } from '../services/api/settingsApi';

interface InboxState {
  /** Customer conversations with unread messages (a human should look). */
  unread: number;
  refresh: () => Promise<void>;
}

/**
 * Tracks how many customer conversations are unread so the sidebar can show a
 * count badge on "Unified Inbox" — even when the inbox page isn't mounted.
 * Refreshed by a lightweight poll in the app layout, via the dedicated COUNT
 * endpoint (the previous version fetched the entire conversation list every
 * minute just to count it, and counted status==='open' — which never cleared,
 * so the badge overcounted forever). Best-effort: transient errors leave the
 * count untouched.
 */
export const useInboxStore = create<InboxState>((set) => ({
  unread: 0,
  refresh: async () => {
    try {
      const res = await inboxApi.getUnreadCount();
      const unread = res?.data?.unread;
      if (typeof unread === 'number') set({ unread });
    } catch {
      // ignore — the badge is non-critical
    }
  },
}));

export default useInboxStore;
